import { render, staticRenderFns } from "./StokListesiYeni.vue?vue&type=template&id=6a927bde"
import script from "./StokListesiYeni.vue?vue&type=script&lang=js"
export * from "./StokListesiYeni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports